import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import "./IntegrationShowModal.css";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";

const IntegrationShowModal = NiceModal.create(({integration}) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    return (
        <Modal name="change-password" id={modal.id} autoClose="true" onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <div className="title_integration_modal">
                Dataset list of my integration
                <div className="list_faqs_integrations">

                    {
                        Array.isArray(integration.datasets) ?
                            integration.datasets.map((dataset, i) => {
                                return (
                                    <span className="integration_row_faq">
                                         <i style={{ marginRight: '15px', fontSize:"20px"}} className={'flag-icon flag-icon-' + dataset.language.slug.toLowerCase()}></i>
                                          <a href={urlWithRoutingCompany('/datasets/'+ dataset.name)}><div className="name_list "> {dataset.name} </div></a>
                                     </span>
                                )
                            })
                            :
                            null
                    }
                </div>

            </div>


        </Modal >
    )
});

export default IntegrationShowModal;